import { useGetSpaPackageExtras } from '@features/spa/hooks/useGetSpaPackageExtras';
import { some } from '@utils/some';
import moment from 'moment';
import { SpaExtras } from '../ExtrasStep/Extras/SpaExtras';
import { ExtrasWrapper } from '../ExtrasStep/ExtrasSection.styles';
import { useHashNavigation } from '../hooks/useHashNavigation';
import { useStepFooter } from '../hooks/useStepFooter';
import { SpaExtrasWrapper } from './SpaExtrasStep.styles';
import { usePackageConfiguration } from '../../contexts';
import { formatDateISO } from '../../helpers/dateFormatters';

export const SpaExtrasStep = () => {
  const { property, language, journeyParams, spaPackageId } = usePackageConfiguration();

  useHashNavigation({ hash: 'spaExtrasStep' });

  const { data: extras = [] } = useGetSpaPackageExtras(
    property.id,
    Number(spaPackageId),
    language,
    formatDateISO(moment(journeyParams.fromDate)),
    true
  );

  const footer = useStepFooter();

  return (
    <>
      <SpaExtrasWrapper>
        {some(extras) && (
          <ExtrasWrapper>
            <SpaExtras extras={extras} />
          </ExtrasWrapper>
        )}
      </SpaExtrasWrapper>
      {footer}
    </>
  );
};
